<template>
    <div v-if="dialogVisible" class="inner-frame">
        <div class="inner-frame-container">
            <i class="el-icon-close inner-frame-close" @click="close"></i>
            <iframe :src="src" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        src: {
            type: String
        }
    },
    data() {
        return {
        }
    },
    methods: {
        close() {
            this.$emit("close")
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.inner-frame {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: black;
    background: rgba(0, 0, 0, .8);
    z-index: 1001;

    .inner-frame-container {
        width: 70%;
        height: 90%;
        position: relative;
        margin: 5% auto;
        border-radius: 15px;
        box-shadow: 0 0 30px #fff;

        .inner-frame-close {
            font-size: 30px;
            color: #ff5111;
            position: absolute;
            right: 20px;
            top: 10px;
            z-index: 2;
        }

        iframe {
            border-radius: 15px;
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 1;
        }
    }

    @media (max-width: 900px) {
        .inner-frame-container {
            width: 100%;
            height: 100%;
            margin: 0 auto;
            border-radius: 0;
        }

        iframe {
            border-radius: 0 !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/innerFrame.vue